// 处理订单详情页 订单、票等逻辑
import { formatDate, parseDate } from '@/utils/baseDate'
import { TicketStatus } from '@/common/enum'
import dayjs from 'dayjs'

export function compareNow(date) {
  const now = new Date().getTime()
  const day = parseDate(date).getTime()
  return now - day
}
export function showBtns(ticket) {
  const {
    from_station_telecode, // 出发站3字码 XJA-九龙
    pre_ticket_id,
    cross_border,
    start_time
  } = ticket
  const isCross = cross_border === 1 // 是否是跨境列车
  const isChange = !!pre_ticket_id // 是否已改签
  const isXJA = from_station_telecode === 'XJA' // 始发站是否是九龙站

  const time_offset = !isCross
    ? 0
    : isXJA
      ? -1000 * 45 * 60 // 45分钟前
      : -1000 * 30 * 60 // 30分钟前

  const last_time = !isCross
    ? formatDate(start_time) + ' 23:59:59' // 发车时间24点前
    : start_time // 发车时间

  const isTimeout = compareNow(last_time) > time_offset

  // 跨境列车+改签 超时 都不展示
  const showbtns = !(isCross && isChange) && !isTimeout

  return showbtns
}

export function showChangeBtn(ticket) {
  const { status, pre_ticket_id } = ticket || {}
  const show = showBtns(ticket)
  // 已出票 & 未改签
  return status === TicketStatus.ISSUED && !pre_ticket_id && show
}

export function showRefundBtn(ticket, allTickets) {
  const { status, start_time, pre_ticket_id, create_time } = ticket || {}
  const show = showBtns(ticket)
  const specificTime = dayjs(start_time).add(1, 'hour');
  const isTimeout = specificTime.isBefore(dayjs()) // 是否超出发车时间一小时 12.26改动
  let isChangeAfterGo = false // 是否是在发车后改签的
  if (pre_ticket_id && create_time) {
    const pre_ticket_start_time = allTickets[pre_ticket_id]?.start_time // 原票发车时间
    isChangeAfterGo = parseDate(create_time).getTime() >= pre_ticket_start_time
  }
  const canRefund =
    [TicketStatus.ISSUED, TicketStatus.OFFLINE_REISSUE].includes(status) &&
    !isTimeout &&
    !isChangeAfterGo &&
    show
  return canRefund
}